module.exports = __webpack_public_path__ + "static/media/animation1.69efa258.jpg";